import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import '@fontsource/roboto';
import './assets/styles/app.css';
import '@sweetalert2/theme-material-ui/material-ui.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
